









import Vue from 'vue';
import UnternehmenFilters from '@/components/Unternehmen/UnternehmenFilters.vue';
import UnternehmenList from '@/components/Unternehmen/UnternehmenList.vue';

export default Vue.extend({
  name: 'Unternehmen',
  components: {
    UnternehmenFilters,
    UnternehmenList,
  },
  mounted() {
    this.$store.dispatch('loadLehrstellen');
  },
});
